import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import Tooltip from '@sumologic/yama-ds-components/components/Tooltip';

import Entity from '~/models/Entity';

import { toErrorMessage } from '~/modules/helpers/error';
import { returnCorrectPath } from '~/modules/manageRouting';

import Loader from '~/components/Loader/Loader';
import Translate from '~/components/Translate/Translate';
import SimpleModal from '~/components/SimpleModal/SimpleModal';
import NoDataToShow from '~/containers/NoDataToShow/NoDataToShow';

import StickyAlertContext from '~/containers/StickyAlertManager/StickyAlertContext';

const IncidentDetailLink = props => {
    // 𝘦𝘹𝘱𝘦𝘤𝘵𝘦𝘥 𝘵𝘰 𝘣𝘦 𝘪𝘯𝘴𝘪𝘥𝘦 𝘢 <Router>
    const url = returnCorrectPath('incidentsDetails', false, props.id);
    return <Link to={url}>{props.label}</Link>;
};

// prettier-ignore
const InvolvedIncidentsLinkedListModal = props => {
    const stickyAlertContext = useContext(StickyAlertContext);
    const [showModal, setShowModal] = useState(false);
    const [list, setList] = useState(null);
    const ref = useRef({}).current;

    useEffect(() => {
        ref.isMounted = true;
        return () => {
            ref.isMounted = false;
        };
    }, []);

    return (
        <a
            className="ag-involved-incidents rest"
            style={{
                userSelect: 'none',
                cursor: 'pointer'
            }}
            onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                // console.log('𝘴𝘺𝘯𝘵𝘩𝘦𝘵𝘪𝘤𝘉𝘢𝘴𝘦𝘌𝘷𝘦𝘯𝘵', event);
                if (!showModal) {
                    setList(null);
                    setShowModal(true);
                    Entity.involvedIncidents(props.type, props.id)
                        .then(response => {
                            if (ref.isMounted) {
                                const respData = response.data;
                                if (respData?.error || 200 !== response.status) {
                                    throw response;
                                } else {
                                    setList(
                                        respData || []
                                    );
                                }
                            }
                        })
                        .catch(exception => {
                            if (APP_INFO.debug) {
                                console.debug(exception);
                            }
                            if (ref.isMounted) {
                                stickyAlertContext.notifyError({
                                    title: <Translate message="Error" />,
                                    message: toErrorMessage(exception,
                                        <Translate message="Something went wrong getting involved incidents" />
                                    )
                                });
                                setShowModal(false);
                            }
                        });
                }
            }}
        >
            &ensp;+&thinsp;
            <b>
                {props.count}
            </b>
            &ensp;
            {showModal && (
                <SimpleModal
                    show={true}
                    setShow={setShowModal}
                    size={props.size}
                    data-testid="modal-involved-incidents"
                    id="modal-involved-incidents"
                    title="Involved incidents"
                    dismissLabel="Close"
                    noApplyButton
                >
                    {list ? (
                        <div
                            className={
                                `link-list ${
                                    list.length ? 'has' : 'no'
                                }-data`
                            }
                        >
                            {list.length ? (
                                <ul className="data">
                                    {list.map(({ name, id }, index) => {
                                        const label = name || id;
                                        return label ? (
                                            <li key={index}>
                                                <Tooltip
                                                    title={label}
                                                    placement="top"
                                                    arrow
                                                    classes={{ tooltip: 'tooltip-involved-incident-link' }}
                                                >
                                                    <span>
                                                        <IncidentDetailLink
                                                            label={label}
                                                            id={id}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </li>
                                        ) : null;
                                    })}
                                </ul>
                            ) : (
                                <NoDataToShow className="no-results-found" />
                            )}
                        </div>
                    ) : (
                        <Loader />
                    )}
                </SimpleModal>
            )}
        </a>
    );
};

// 𝖲𝖤𝖢𝖳𝖨𝖮𝖭-𝖲𝖨𝖦𝖭 \u00a7
export const splitRE = /(\d+)§(.+)/;

// prettier-ignore
export const involvedIncidentsCellRender = params => {
    const { data, value } = params;
    if (data && value) {
        const total = value.count;
        if (total) {
            let notLinked = total;
            const separator = '\u200D,\u0020';
            const pattern = splitRE;
            const links = [];
            for (const str of value.details) {
                const matches = str?.match?.(pattern);
                // console.log({ str, matches });
                if (matches) {
                    --notLinked;
                    links.push(
                        <IncidentDetailLink
                            key={links.length}
                            label={
                                matches[2] // 𝘪𝘯𝘤𝘪𝘥𝘦𝘯𝘵 𝗻𝗮𝗺𝗲
                            }
                            id={
                                matches[1] // 𝘪𝘯𝘤𝘪𝘥𝘦𝘯𝘵 𝗶𝗱
                            }
                        />,
                        separator
                    );
                }
            }
            if (links.length > 1) {
                --links.length; // 𝘳𝘦𝘮𝘰𝘷𝘦 𝘭𝘢𝘴𝘵 𝘴𝘦𝘱𝘢𝘳𝘢𝘵𝘰𝘳
            }
            return (
                <div className="d-flex">
                    <span className="text-truncate">
                        {links}
                    </span>
                    {0 < notLinked && (
                        <InvolvedIncidentsLinkedListModal
                            id={data.id}
                            type={data.type?.replace('\u0020', '_')}
                            count={notLinked}
                            size={total > 150 ? 'xl' : 'md'}
                        />
                    )}
                </div>
            );
        }
    }
    return '';
};
